(function (factory) {
  typeof define === 'function' && define.amd ? define(factory) :
  factory();
})((function () { 'use strict';

  (function(){
    /**
     * Handles toggling the megamenu for desktop - hover events only
     */

    let hover_opts = {
      sensitivity: 8,
      timeout: 100,
      handleFocus: true
    };

    // adding the focus class allows the hover effect to linger, so that
    // the user can move their mouse across another link by accident
    // on the way to the desired submenu links (esp noticable on "About")
    const toggles = document.querySelectorAll('#primary-menu .menu-item');
    if (!toggles) return;
    for (let toggle of toggles) {
      hoverintent(
        toggle,
        () => {
          toggle.className += ' focus';
        },
        () => {
          toggle.className = toggle.className.replace(' focus', '');
        }
      ).options(hover_opts);
    }

  })();


  // TODO: test touch on larger screens (test on kindle?)
  // TODO: multi-columns by item count (she has 5 staying 1-col, but 6 breaking to 4x2...)
  // TODO: images are too wide - esp if there are multi-cols. width should be consistant.
  //       might be able to control this with only cloudinary, no code.
  // TODO: make the image link less user-error-prone - move to theme.php except file name???
  // TODO: sticky menu on scroll? where does search go? announcement bar?

}));
